import RegisterView from './Register.view';
import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { t } from 'src/i18n';

const enhance = compose(
  withProps({ title: t('general.register') }),
  withHelmet
);

export default enhance(RegisterView);
